import { Link } from 'react-router-dom';
import Aurora from '../home/components/Aurora';
import { CursorGlow } from '../home/components/CursorGlow';

export default function AboutPage() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Aurora Background */}
      <div className="fixed inset-0 z-0">
        <Aurora 
          colorStops={['#ed66ff', '#b19eef', '#5227ff']}
          amplitude={1.2}
          blend={0.6}
          speed={0.8}
        />
      </div>

      {/* Global Effects */}
      <CursorGlow />

      {/* Content */}
      <div className="relative z-10">
        <div className="absolute inset-0 bg-black/30"></div>
        
        <div className="relative z-10 pt-24 sm:pt-28 md:pt-32 pb-16 sm:pb-20 md:pb-24">
          <div className="container mx-auto px-4 sm:px-6">
            {/* Header */}
            <div className="text-center mb-12 sm:mb-16 md:mb-20">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.1em] px-4">
                ABOUT <span className="bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">TEHK ZONE</span>
              </h1>
              <p className="text-gray-400 text-base sm:text-lg md:text-xl max-w-3xl mx-auto font-light leading-relaxed px-4">
                Bridging the gap between creativity and technology in today's business world
              </p>
            </div>

            {/* Main Content */}
            <div className="max-w-5xl mx-auto space-y-12 sm:space-y-16">
              {/* Introduction */}
              <div className="bg-black/40 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 sm:p-8 md:p-10">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-wide">
                  Who We Are
                </h2>
                <p className="text-gray-400 text-base sm:text-lg leading-relaxed mb-4 sm:mb-6">
                  Tehk Zone Inc. is a dynamic and innovative African-American marketing, media, and technology solutions company, with official registrations in California, United States, and Nigeria. We were established with a clear purpose: to bridge the gap between creativity and technology in today's business world. In a rapidly evolving digital economy, businesses face the challenge of not only competing for attention but also maintaining sustainable growth.
                </p>
                <p className="text-gray-400 text-base sm:text-lg leading-relaxed">
                  At Tehk Zone, we help organizations achieve this by delivering high-quality services in branding, digital marketing, software development, creative design, media production, and the supply of high-tech gadgets. Our international presence allows us to serve clients across continents with a unique blend of global expertise and local understanding.
                </p>
              </div>

              {/* Professional Images Showcase */}
              <section className="py-12 sm:py-16 md:py-20">
                <div className="container mx-auto px-4 sm:px-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
                    <div className="group relative overflow-hidden rounded-2xl">
                      <img 
                        src="https://static.readdy.ai/image/8ff5f191f084c4fb11b85d16f9e2729c/da53d9380322dc8eccbe9566bc33a744.jpeg"
                        alt="Collaborative Excellence"
                        className="w-full h-64 sm:h-72 md:h-80 object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-4 sm:p-6">
                        <h3 className="text-white text-lg sm:text-xl font-semibold">Collaborative Excellence</h3>
                      </div>
                    </div>
                    <div className="group relative overflow-hidden rounded-2xl">
                      <img 
                        src="https://static.readdy.ai/image/8ff5f191f084c4fb11b85d16f9e2729c/3310434f8b5ad9926db508e6e099a009.jpeg"
                        alt="Media Production"
                        className="w-full h-64 sm:h-72 md:h-80 object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-4 sm:p-6">
                        <h3 className="text-white text-lg sm:text-xl font-semibold">Media Production</h3>
                      </div>
                    </div>
                    <div className="group relative overflow-hidden rounded-2xl sm:col-span-2 md:col-span-1">
                      <img 
                        src="https://static.readdy.ai/image/8ff5f191f084c4fb11b85d16f9e2729c/87caaedd36639523ce57d8ab00c7f66d.jpeg"
                        alt="Technology Solutions"
                        className="w-full h-64 sm:h-72 md:h-80 object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-4 sm:p-6">
                        <h3 className="text-white text-lg sm:text-xl font-semibold">Technology Solutions</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Companies We Work With Section */}
              <section className="py-12 sm:py-16 md:py-20 bg-black/30 backdrop-blur-sm rounded-2xl">
                <div className="container mx-auto px-4 sm:px-6">
                  <div className="text-center mb-10 sm:mb-12 md:mb-16">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
                      Companies We Work With
                    </h2>
                    <p className="text-gray-300 text-base sm:text-lg max-w-2xl mx-auto px-4">
                      Trusted by leading organizations across various industries
                    </p>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
                    {[
                      'Rolex',
                      'Ronchess Global',
                      'Hypure1 Switzerland',
                      'Afwan Agritech Company',
                      'Kaduna State Urban Planning and Development Authority',
                      'Kaduna Investment and Promotion Agency',
                      'Flexisaf',
                      'B.O.B Textiles Limited',
                      'B.O.B Real Estate Company',
                      'Joserose Hotel and Suites',
                      'Capemay Properties'
                    ].map((company, index) => (
                      <div 
                        key={index}
                        className="group relative bg-white/5 backdrop-blur-sm rounded-xl p-5 sm:p-6 border border-white/10 hover:border-purple-400/50 transition-all duration-300 hover:bg-white/10 flex items-center justify-center min-h-[100px] sm:min-h-[120px]"
                      >
                        <h3 className="text-white text-center font-semibold text-sm md:text-base group-hover:text-purple-300 transition-colors duration-300">
                          {company}
                        </h3>
                      </div>
                    ))}
                  </div>
                </div>
              </section>

              {/* Commitment */}
              <div className="bg-black/40 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 sm:p-8 md:p-10">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-wide">
                  Our Commitment
                </h2>
                <p className="text-gray-400 text-base sm:text-lg leading-relaxed">
                  With a strong commitment to excellence, we serve businesses of all sizes from startups seeking brand identity to established organizations requiring advanced technological support. Our solutions are tailored, practical, and results-driven, positioning us as a trusted partner for clients in various industries.
                </p>
              </div>

              {/* Core Values */}
              <div className="bg-black/40 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 sm:p-8 md:p-10">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-6 sm:mb-8 tracking-wide">
                  Our Core Values
                </h2>
                <p className="text-gray-400 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8">
                  At Tehk Zone, our core values are more than just words, they are the heartbeat of everything we do. They guide our creativity, shape our strategies, and define how we work with our clients and each other. Every project we take on is built on a foundation of trust, consistency, and innovation.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
                  <div className="bg-gradient-to-br from-violet-500/10 to-purple-500/10 border border-purple-500/30 rounded-xl p-5 sm:p-6">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-purple-500/20 rounded-xl mb-3 sm:mb-4">
                      <i className="ri-lightbulb-line text-2xl sm:text-3xl text-purple-400"></i>
                    </div>
                    <h3 className="text-lg sm:text-xl font-light text-white mb-2 sm:mb-3">Innovation</h3>
                    <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                      Constantly pushing boundaries and embracing new technologies to deliver cutting-edge solutions
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-violet-500/10 to-purple-500/10 border border-purple-500/30 rounded-xl p-5 sm:p-6">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-purple-500/20 rounded-xl mb-3 sm:mb-4">
                      <i className="ri-star-line text-2xl sm:text-3xl text-purple-400"></i>
                    </div>
                    <h3 className="text-lg sm:text-xl font-light text-white mb-2 sm:mb-3">Excellence</h3>
                    <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                      Delivering exceptional quality in every project, exceeding expectations at every turn
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-violet-500/10 to-purple-500/10 border border-purple-500/30 rounded-xl p-5 sm:p-6">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-purple-500/20 rounded-xl mb-3 sm:mb-4">
                      <i className="ri-user-heart-line text-2xl sm:text-3xl text-purple-400"></i>
                    </div>
                    <h3 className="text-lg sm:text-xl font-light text-white mb-2 sm:mb-3">Customer Focus</h3>
                    <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                      Putting clients first, understanding their needs, and building lasting partnerships
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-violet-500/10 to-purple-500/10 border border-purple-500/30 rounded-xl p-5 sm:p-6">
                    <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-purple-500/20 rounded-xl mb-3 sm:mb-4">
                      <i className="ri-line-chart-line text-2xl sm:text-3xl text-purple-400"></i>
                    </div>
                    <h3 className="text-lg sm:text-xl font-light text-white mb-2 sm:mb-3">Growth</h3>
                    <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                      Committed to continuous improvement and helping our clients achieve sustainable success
                    </p>
                  </div>
                </div>
              </div>

              {/* Conclusion */}
              <div className="bg-gradient-to-r from-violet-500/10 to-purple-500/10 border border-purple-500/30 rounded-2xl p-6 sm:p-8 md:p-10 text-center">
                <h2 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-wide">
                  More Than Just a Company
                </h2>
                <p className="text-gray-400 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8 max-w-3xl mx-auto">
                  Tehk Zone is more than just a marketing and technology company—we are a strategic partner for businesses and organizations seeking sustainable growth in a digital age. Our blend of creativity, innovation, and technical expertise ensures that we not only meet expectations but exceed them.
                </p>
                <Link 
                  to="/contact"
                  className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-violet-500 to-purple-500 text-white text-sm sm:text-base rounded-xl hover:shadow-lg hover:shadow-purple-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Partner With Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
